import { Auth } from '@/utils';
import { base } from '../../utils';

export const deleteFollow = async (userId, followId) => {
  const token = await Auth.getIdToken();
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  try {
    const url = `/v1/users/${userId}/follows/${followId}`;

    await base.delete(url, { headers });

    return;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
